import { ORDER_ACCESS } from '../../../security.attributes';
export var ORDERS_STATE_NAME = 'index.customercare.customer.orders';
export default (function ($stateProvider) {
  $stateProvider.state(ORDERS_STATE_NAME, {
    url: '/orders',
    template: '<orders ui-view></orders>',
    securityAttributes: [ORDER_ACCESS]
  });
});